import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Layout, Select } from 'antd';

import { setUISettings } from '../../../actions/UICustomizationActions'
import { setDeviceMode } from '../../../actions/ui/DeviceModeActions'
import { getProjects, resetSelectedProject } from '../../../actions/projects/ProjectsActions'

import RolesHelper from '../../../services/permisions/RolesHelper';
import AccountMenu from '../../header/AccountMenu';

import { DeviceModeEnum } from '../../../constants/DeviceModeEnum'
import { RoutePath } from '../../../constants/SitePaths';
import config from '../../../constants/Configs';
import ProjectStateEnum from '../../../constants/ProjectStateEnum'
import { useTranslations } from '../../../hooks/useTranslations';

const { Header } = Layout;
const { Option } = Select;

function SiteHeader() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const deviceMode = useSelector(state => state.builder.ui.deviceMode);
    const selectedProject = useSelector(state => state.builder.projects.selectedProject);
    const allProjects = useSelector(state => state.builder.projects.allProjects);
    const { translations } = useTranslations();

    const save = (props) => {
        dispatch(setUISettings(props.configs.currentSettings));
    }

    const changeDeviceMode = (mode) => {
        dispatch(setDeviceMode(mode));
    }

    useEffect(() => {
        !config.NEW_PLAT && dispatch(getProjects());
        return () => dispatch(resetSelectedProject())
    }, []);

    const handleChangeProject = (project) => {
        navigate(`${RoutePath.CUSTOMIZE}/${project.key}?cid=${project.id}&p=${project.key}`);
        window.location.reload(false);
    }

    const { projects = [] } = allProjects;
    const partnersOptions = (
        projects && projects.filter(project => project.state !== ProjectStateEnum.Blocked)
            .sort((a, b) => { return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0) })
            .map(project => (
                <Option className='customization--partner' value={project.name} id={project.parrentPartnerId} key={project.id} >
                    {project.name}
                </Option>
            ))
    );
    return (
        <Header className="header tb--flex tb--align-center tb--justify-between">
            {RolesHelper.isAffilateUser() ?
                <div></div>
                : (!config.NEW_PLAT ? <Link className="logo" to={"/projects"}></Link> : <div className="logo" ></div>)
            }

            <div className='customization--device-picker'>
                <a className='customization--device' onClick={() => changeDeviceMode(DeviceModeEnum.Desktop)}>
                    <i className={deviceMode === DeviceModeEnum.Desktop ? "desktop-bicon active-mode" : "desktop-bicon"}></i>
                </a>
                <a className='customization--device' onClick={() => changeDeviceMode(DeviceModeEnum.Mobile)}>
                    <i className={deviceMode === DeviceModeEnum.Mobile ? "mobile-bicon active-mode" : "mobile-bicon"}></i>
                </a>
            </div>

            <div className='tb--flex tb--align-center'>
                {!config.NEW_PLAT && <Select showSearch key={selectedProject.name} defaultValue={selectedProject.name} className='customization--partners'
                    onChange={(value, selectedProject) => handleChangeProject(selectedProject)}>
                    {partnersOptions}
                </Select>}

                <div className='customization--preview tb--flex tb--align-center'>
                    <a {...(selectedProject && selectedProject.domain ? {} : { className: "tb--hidden-block" })} target="_blank" href={`//${selectedProject && selectedProject.domain}?prev=${new Date().getTime()}`}>
                        <span className='eye-bicon-span'><i className="eye-bicon"></i></span>
                        {translations.preview}
                    </a>
                </div>

                {!config.NEW_PLAT && <AccountMenu showName={false} />}
            </div>
        </Header>
    );
}

export default SiteHeader;



